import { DashboardDateRangeId } from './types';
import * as M from 'moment/moment';
import { DateRange, extendMoment } from 'moment-range';

const moment = extendMoment(M);

export class DashboardDateRange {
  constructor(dateRangeId: DashboardDateRangeId, name?: string, startDate?: string, endDate?: string, parsedStartDate?: string, parsedEndDate?: string) {
    this.dateRangeId = dateRangeId;
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.parsedStartDate = parsedStartDate;
    this.parsedEndDate = parsedEndDate;
    if (startDate && endDate) this.isInitialized = true;
  }

  readonly dateRangeId: DashboardDateRangeId;

  readonly name?: string;

  readonly startDate?: string;

  readonly endDate?: string;

  readonly parsedStartDate?: string;

  readonly parsedEndDate?: string;

  private isInitialized = false;

  getDateHelperDisplayName(): string {
    if (this.isInitialized) {
      if (this.name) {
        return this.name;
      } else {
        if (this.parsedStartDate === this.parsedEndDate) return this.parsedStartDate || '';
        else return `${this.parsedStartDate} - ${this.parsedEndDate}`;
      }
    } else return '';
  }

  getMomentDateRange(): DateRange {
    return moment.range(moment(this.parsedStartDate), moment(this.parsedEndDate));
  }
}
